import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { focusStyle } from "./fieldStyles";

const ReferencedInputAndSubmit = ({ namedReference, onClick, label, style, type = "text" }) => {
  const buttonLabel = label ?? <><FontAwesomeIcon icon={faAdd} /> Add</>;

  return (
    <div style={{ display: "flex", gap: "8px", ...style }}>
      <style>{focusStyle}</style>
      <input
        ref={namedReference}
        type={type}
        className="field-modern"
        style={{ flex: 1 }}
      />
      <button
        type="button"
        onClick={onClick}
        style={{
          background: "#1a73e8",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          padding: "9px 16px",
          fontSize: "0.88rem",
          fontWeight: 600,
          cursor: "pointer",
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          gap: "6px",
          whiteSpace: "nowrap",
        }}
      >
        {buttonLabel}
      </button>
    </div>
  );
};

export default ReferencedInputAndSubmit;
